import request from "../axios";

export const updateResourcesFromYoutube = () => request.get('/api/youtube/channel/update/resources');